import type { Nil, TableFilter } from '@pbt/pbt-ui-components'

import type { AmountWithUnit, AmountWithUnitId, ContactSlot } from '..'

export type TaskRecurrencePeriod = {
  daysOfWeek?: string[]
  recurrencePeriod?: AmountWithUnit | null
  timesOfDay?: string[]
}

export type TaskRecurrence = TaskRecurrencePeriod & {
  dueDate?: string | null
  dueTime?: string | null
  occurrencesCount?: number | null
  recurrenceEndDatetime?: string | null
  recurrenceModeId?: string | null
}

export type BundleTaskRecurrence = {
  dueDateOptionId?: string
  dueTimeOptionId?: string
  endDateOptionId?: string | null
  endTimeOptionId?: string | null
  recurrenceModeId?: string | null
  specificDueTime?: string | null
  specificEndTime?: string | null
}

export type TaskCustomDueDateRecurrence = {
  customDueDateOffset?: AmountWithUnit | null
}

export type TaskCustomEndDate = {
  customEndDateOffset?: AmountWithUnit | null
}

export type SoapTask = {
  appointmentId?: string | null
  assigned?: string
  children?: string[]
  clientId?: string
  dueDate?: string | null
  forClient?: boolean
  id: string
  name: string
  notes: string
  occurrencesCount?: number | null
  recurrenceEndDatetime?: string | null
  recurrenceModeId?: string | null
  recurrencePeriod?: AmountWithUnit | null
  soapId?: string | null
  stateId?: string
  typeId: string
}

export type ClientTask = {
  dueDateTime: string
  name: string
  occurrencesCount?: number | null
  recurrenceEndDateTime?: string | null
  recurrenceOffset?: AmountWithUnitId | null
}

export type Task = TaskRecurrence &
  TaskCustomDueDateRecurrence &
  TaskCustomEndDate &
  BundleTaskRecurrence &
  ContactSlot & {
    aggregatedStateId?: string
    appointment?: string
    appointmentId?: string | null
    assigned?: string
    assignedId?: string
    assigneeId?: string
    businessId?: string
    children?: string[]
    client?: string
    clientNotes?: string
    completionDate?: string
    contact?: string
    creationDate?: string
    dueDatetime?: string
    forChewyVcr?: boolean
    forClient?: boolean
    id: string
    instructions?: string
    modificationDate?: string
    name: string
    notes: string | Nil
    orderId?: string | null
    orderType?: string | null
    patient?: string
    prescriptionId?: string | null
    sharedToPersonIds?: string[]
    shouldCreateTask?: boolean // Flag to determine if task should actually be created
    soapId?: string | null
    space?: {
      name: string
    }
    stateId?: string
    teamId?: string
    teamMemberOptionId?: string
    typeId: string
  }

export type TaskTypesType =
  | 'Callback'
  | 'Feeding'
  | 'Grooming'
  | 'Lab review'
  | 'Medications'
  | 'Other'
  | 'Play'
  | 'Rx Request'
  | 'SOAP'
  | 'Training'
  | 'Treatments'
  | 'Vet Diet Request'
  | 'Vitals'
  | 'Walks'

export enum SortMode {
  CHRONOLOGICAL = 'CHRONOLOGICAL',
  PRIORITY = 'PRIORITY',
  LEGACY = 'LEGACY',
}

export type TaskTableFilter = TableFilter & {
  sortMode?: SortMode
}
